import api from "./api";

export const reportService = {
  getReport: async (endpoint: string, filters?: Record<string, any>) => {
    return await api.get(endpoint, filters);
  },

  getReportPdf: async (pdfEndpoint: string, filters?: Record<string, any>): Promise<Blob> => {
    return await api.getBlob(pdfEndpoint, filters);
  },

  getStaffList: async () => {
    return await api.get("/reports/filters/staff");
  },

  getRoomList: async () => {
    return await api.get("/reports/filters/rooms");
  },

  downloadPdf: (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  },
};
